import DOMPurify from 'isomorphic-dompurify';
// import sanitizeHtml from 'sanitize-html';

export default function sanitize({ raw, limit, textOnly = false }: { raw: string; limit?: number; textOnly?: boolean; }) {
  const text: string = DOMPurify.sanitize(raw, getOptions({ multiline: false }));
  const hasMore = !!limit && text.length > limit;

  const full: string = textOnly ? text : (DOMPurify.sanitize(raw, getOptions({ multiline: true }))).replace(/(<br \/>)*$/, '');
  const truncated = clipText({
    text: DOMPurify.sanitize(full, getOptions({ multiline: false })),
    length: limit,
  });

  return {
    truncated,
    full,
    hasMore,
  };
}

function clipText({ text, length }: { text: string; length?: number }): string {
  if (length && text.length <= length) return text;

  const truncated = text.substring(0, (length || text.length) - 1);
  const lastSpaceIndex = truncated?.lastIndexOf(' ');
  return truncated?.substring(0, lastSpaceIndex) + '...';
}

const getOptions = ({ multiline = true }: { multiline?: boolean; textOnly?: boolean; }) => {
  const options = {
    ALLOWED_TAGS: [
      'b', 'strong', 'a', 'i', 'em',
    ],
    ALLOWED_ATTR: ['href'],
    // allowedSchemes: ['https'],
    // allowedSchemesByTag: {},
    // allowedSchemesAppliedToAttributes: ['href'],
    // allowProtocolRelative: true,
    // enforceHtmlBoundary: false,
  };

  if (!multiline) return options;

  return Object.assign(options, {
    // selfClosing: ['br'],
    ALLOWED_TAGS: [...options.ALLOWED_TAGS, 'br'],
  });
};
